export default __webpack_public_path__ + "static/media/no-data-found.0286a58e.svg";